/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CalculationStatus {
  Failed = "Failed",
  Successful = "Successful",
}

export enum EmailNotificationStatus {
  Failed = "Failed",
  Processing = "Processing",
  Sent = "Sent",
  Triggered = "Triggered",
}

export enum IScopedPermission__SolutionScope {
  ArchiveAndRestoreSolution = "ArchiveAndRestoreSolution",
  CalculateWebServices = "CalculateWebServices",
  ChangeProjects = "ChangeProjects",
  ChangeServiceProducts = "ChangeServiceProducts",
  ChangeSolutionDetail = "ChangeSolutionDetail",
  ChangeSolutionMemberPermissions = "ChangeSolutionMemberPermissions",
  ChangeWebServiceData = "ChangeWebServiceData",
  ChangeWebServices = "ChangeWebServices",
  DeleteProjects = "DeleteProjects",
  DeletePublicApiRequests = "DeletePublicApiRequests",
  DeleteWebServices = "DeleteWebServices",
  DownloadCalculationRule = "DownloadCalculationRule",
  InviteSolutionMember = "InviteSolutionMember",
  ReadAllCalculations = "ReadAllCalculations",
  ReadAllWebServiceData = "ReadAllWebServiceData",
  ReadProjects = "ReadProjects",
  ReadPublicApi = "ReadPublicApi",
  ReadPublicApiRequests = "ReadPublicApiRequests",
  ReadServiceProducts = "ReadServiceProducts",
  ReadSolutionDetail = "ReadSolutionDetail",
  ReadSolutionMembers = "ReadSolutionMembers",
  ReadTransactions = "ReadTransactions",
  ReadWebServices = "ReadWebServices",
  RemoveSolutionMember = "RemoveSolutionMember",
}

export enum IScopedPermission__TenantScope {
  ChangeApiKeys = "ChangeApiKeys",
  ChangeTenantMemberPermissions = "ChangeTenantMemberPermissions",
  ChangeWorkspaces = "ChangeWorkspaces",
  CreateSolution = "CreateSolution",
  CreateUser = "CreateUser",
  DeleteArchivedSolution = "DeleteArchivedSolution",
  DeleteRateAgreements = "DeleteRateAgreements",
  DeleteRateTables = "DeleteRateTables",
  DeleteRates = "DeleteRates",
  ManageAccessGrants = "ManageAccessGrants",
  ReadAllSolutions = "ReadAllSolutions",
  ReadApiKeys = "ReadApiKeys",
  ReadConfiguration = "ReadConfiguration",
  ReadTenantMemberPermissions = "ReadTenantMemberPermissions",
  ReadUsers = "ReadUsers",
  ReadWorkspaces = "ReadWorkspaces",
  RemoveUser = "RemoveUser",
}

export enum JobState {
  Completed = "Completed",
  Failed = "Failed",
  InProgress = "InProgress",
  Scheduled = "Scheduled",
}

export enum LimitType {
  Hard = "Hard",
  Soft = "Soft",
}

export enum ProjectState {
  Created = "Created",
  Failed = "Failed",
  InProgress = "InProgress",
  Scheduled = "Scheduled",
}

export enum ReleaseType {
  Initial = "Initial",
  Major = "Major",
  Minor = "Minor",
  Patch = "Patch",
}

export enum ScalingType {
  ScaleIn = "ScaleIn",
  ScaleOut = "ScaleOut",
}

export enum ScopedRole__SolutionScope {
  Admin = "Admin",
  ProjectManager = "ProjectManager",
  PublicApiTester = "PublicApiTester",
  User = "User",
}

export enum ScopedRole__TenantScope {
  Admin = "Admin",
  ApiKeyManager = "ApiKeyManager",
  SolutionCreator = "SolutionCreator",
  UserManager = "UserManager",
  WorkspaceManager = "WorkspaceManager",
}

export enum ScsUserType {
  Admin = "Admin",
  Modeler = "Modeler",
  Standard = "Standard",
  Viewer = "Viewer",
}

export enum ServiceProductStatus {
  Active = "Active",
  Deactivated = "Deactivated",
  Expired = "Expired",
  Upcoming = "Upcoming",
}

export enum TransactionPackage {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
}

export interface AddDataCellInput {
  key: string;
  value?: JsonValue | null;
}

export interface AddDataTableInput {
  name: string;
  rows: AddDataCellInput[][];
}

export interface ApiKeyDefinitionInput {
  name: string;
  transactionPackage: TransactionPackage;
  enabled?: boolean | null;
}

export interface DateTimeRangeFilterInput {
  from?: DateTime | null;
  to?: DateTime | null;
}

export interface NotificationTriggerInput {
  email: string;
  thresholds: Decimal[];
}

export interface ProjectDefinitionInput {
  name: string;
  description?: string | null;
  image?: string | null;
  workspaceId: string;
  databaseTemplateId: string;
  tags?: string[] | null;
}

export interface ServiceProductPeriodInputInput {
  startDate: DateTime;
  endDate: DateTime;
}

export interface SolutionDefinitionInput {
  key: Key;
  name: string;
  description: string;
  projectsEnabled: boolean;
  useCasesEnabled: boolean;
}

export interface UseCaseDefinitionInput {
  key: Key;
  name: string;
  tags: string[];
  calculationRuleAddress: string;
  image?: string | null;
  description?: string | null;
  transactionTable?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
